"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "player-tags" };
const _hoisted_2 = { class: "player-tags-main" };
const _hoisted_3 = ["data-tooltip"];
const _hoisted_4 = { class: "tag-and-discount" };
const _hoisted_5 = { class: "player-tags-secondary" };
const _hoisted_6 = {
    key: 0,
    class: "tag-and-discount"
};
const _hoisted_7 = {
    key: 1,
    class: "tag-separator"
};
const _hoisted_8 = {
    key: 2,
    class: "tag-and-discount"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_tag_count = (0, vue_1.resolveComponent)("tag-count");
    const _component_PlayerTagDiscount = (0, vue_1.resolveComponent)("PlayerTagDiscount");
    const _component_PointsPerTag = (0, vue_1.resolveComponent)("PointsPerTag");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createVNode)(_component_tag_count, {
                tag: "vp",
                count: _ctx.hideVpCount ? '?' : _ctx.player.victoryPointsBreakdown.total,
                size: 'big',
                type: 'main'
            }, null, 8, ["count"]),
            (_ctx.isEscapeVelocityOn)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    key: 0,
                    class: (0, vue_1.normalizeClass)(_ctx.tooltipCss),
                    "data-tooltip": _ctx.$t('Escape Velocity penalty')
                }, [
                    (0, vue_1.createVNode)(_component_tag_count, {
                        tag: "escape",
                        count: _ctx.escapeVelocityPenalty,
                        size: 'big',
                        type: 'main',
                        showWhenZero: true
                    }, null, 8, ["count"])
                ], 10, _hoisted_3))
                : (0, vue_1.createCommentVNode)("", true),
            (0, vue_1.createVNode)(_component_tag_count, {
                tag: "tr",
                count: _ctx.player.terraformRating,
                size: 'big',
                type: 'main'
            }, null, 8, ["count"]),
            (_ctx.player.handicap !== undefined)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_tag_count, {
                    key: 1,
                    tag: 'handicap',
                    count: _ctx.player.handicap,
                    size: 'big',
                    type: 'main',
                    showWhenZero: true
                }, null, 8, ["count"]))
                : (0, vue_1.createCommentVNode)("", true),
            (0, vue_1.createElementVNode)("div", _hoisted_4, [
                (_ctx.all.discount)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_PlayerTagDiscount, {
                        key: 0,
                        amount: _ctx.all.discount,
                        color: _ctx.player.color,
                        "data-test": 'discount-all'
                    }, null, 8, ["amount", "color"]))
                    : (0, vue_1.createCommentVNode)("", true),
                (0, vue_1.createVNode)(_component_tag_count, {
                    tag: "cards",
                    count: _ctx.cardsInHandCount,
                    size: 'big',
                    type: 'main'
                }, null, 8, ["count"])
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_5, [
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.tags, (tagDetail) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    class: "tag-count-container",
                    key: tagDetail.name
                }, [
                    (tagDetail.name === _ctx.SpecialTags.UNDERGROUND_TOKEN_COUNT)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_6, [
                            (0, vue_1.createVNode)(_component_tag_count, {
                                tag: tagDetail.name,
                                undergroundToken: _ctx.player.underworldData.activeBonus,
                                count: tagDetail.count,
                                size: 'big',
                                type: 'secondary'
                            }, null, 8, ["tag", "undergroundToken", "count"])
                        ]))
                        : (tagDetail.name === 'separator')
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_7))
                            : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_8, [
                                (tagDetail.discount > 0)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_PlayerTagDiscount, {
                                        key: 0,
                                        color: _ctx.player.color,
                                        amount: tagDetail.discount,
                                        "data-test": 'discount-' + tagDetail.name
                                    }, null, 8, ["color", "amount", "data-test"]))
                                    : (0, vue_1.createCommentVNode)("", true),
                                (0, vue_1.createVNode)(_component_PointsPerTag, { points: tagDetail }, null, 8, ["points"]),
                                (0, vue_1.createVNode)(_component_tag_count, {
                                    tag: tagDetail.name,
                                    count: tagDetail.count,
                                    size: 'big',
                                    type: 'secondary'
                                }, null, 8, ["tag", "count"])
                            ]))
                ]));
            }), 128))
        ])
    ]));
}
